/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingnoplacestitle3Inputs */

const en_crosspostingnoplacestitle3 = /** @type {(inputs: Crosspostingnoplacestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No places yet`)
};

const de_crosspostingnoplacestitle3 = /** @type {(inputs: Crosspostingnoplacestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Orte`)
};

/**
* | output |
* | --- |
* | "No places yet" |
*
* @param {Crosspostingnoplacestitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingnoplacestitle3 = /** @type {((inputs?: Crosspostingnoplacestitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingnoplacestitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingnoplacestitle3(inputs)
	return de_crosspostingnoplacestitle3(inputs)
});
export { crosspostingnoplacestitle3 as "crosspostingNoPlacesTitle" }